import { Route, useLocation, Switch } from "react-router-dom";
import HeaderDefault from "../components/header-default";
import HeaderMobile from "../components/header-mobile";
import Header from "../components/header";
import { BarraInferior } from "../components";
import Login from "./login";
import Home from "./home";
import { UsersPage } from "./administracao";
import { Cashback, RelatorioCashback } from "./cashback";
import ConsultaCashbackCliente from "./consulta_cashback_cliente";

// Todas as rotas do aplicativo
export const ROTAS = [
  ["/", Login],
  [Home.route, Home],
  [UsersPage.route, UsersPage],
  [Cashback.route, Cashback],
  [RelatorioCashback.route, RelatorioCashback],
  [ConsultaCashbackCliente.route, ConsultaCashbackCliente],
];

export default function Routes({ menuSPA, darkMode, setDarkMode, isMobile }) {
  const location = useLocation();
  const pathName = window.location.pathname;
  const pathsNoViewHeader = ["/", ConsultaCashbackCliente.route];
  const pathNameUpdatePasswordUser = "/update_password_user";

  return (
    <>
      {pathsNoViewHeader.includes(pathName) ? (
        <HeaderDefault />
      ) : pathName === pathNameUpdatePasswordUser ? (
        <HeaderDefault />
      ) : isMobile ? (
        <HeaderMobile
          handleDarkMode={() => setDarkMode(!darkMode)}
          darkMode={darkMode}
        />
      ) : (
        <Header
          isMobile={isMobile}
          handleDarkMode={() => setDarkMode(!darkMode)}
          darkMode={darkMode}
          menuSPA={menuSPA}
        />
      )}
      <Switch location={location} key={location.pathname}>
        {ROTAS.map((ele, idx) => (
          <Route component={ele[1]} exact path={ele[0]} key={idx} />
        ))}
      </Switch>
      {pathName !== "/" && (
        <>
          <br /> <br />
          <br />
        </>
      )}
      {isMobile && !pathsNoViewHeader.includes(pathName) && (
        <BarraInferior menuSPA={menuSPA} />
      )}
    </>
  );
}
